import React from "react";
import { SocialMenu } from "./SocialMenu";
import { Copyright } from "./Copyright";
import errorIcon from "./img/error.svg";
export class Contact extends React.Component {
  render() {
    return (
      <div className="contact-wrap">
        <SocialMenu />
        <Copyright />
        <form onSubmit={this.props.handleSubmit} noValidate method="POST">
          <div
            className={
              this.props.fullNameValidated === null ||
              this.props.fullNameValidated
                ? ""
                : "error"
            }
          >
            {this.props.fullName === "" && (
              <label htmlFor="fullName">
                {this.props.fullNameValidated === null ||
                this.props.fullNameValidated
                  ? "imię"
                  : "podaj swoje imię"}{" "}
              </label>
            )}
            {this.props.fullNameValidated === false && (
              <div className="error-icon-wrap">
                <img src={errorIcon} alt="error-icon" />
              </div>
            )}

            <input
              onChange={this.props.handleInputChange}
              required
              type="text"
              name="fullName"
              id="fullName"
              value={this.props.fullName}
            />
          </div>
          <div
            className={
              this.props.emailValidated === null || this.props.emailValidated
                ? ""
                : "error"
            }
          >
            {this.props.email === "" && (
              <label htmlFor="email">
                {this.props.emailValidated === null || this.props.emailValidated
                  ? "e-mail"
                  : "podaj poprawny adres e-mail"}
              </label>
            )}
            {this.props.emailValidated === false && (
              <div className="error-icon-wrap">
                <img src={errorIcon} alt="error-icon" />
              </div>
            )}
            <input
              onChange={this.props.handleInputChange}
              required
              type="email"
              name="email"
              id="email"
              value={this.props.email}
            />
          </div>
          <div
            className={
              this.props.messageValidated === null ||
              this.props.messageValidated === true
                ? ""
                : "error"
            }
          >
            {this.props.message === "" && !this.props.isTextareaActive && (
              <label htmlFor="message" className="message-label">
                {/* {this.props.messageValidated === null ? "hello" : "hello?!"} */}
                hello
              </label>
            )}
            {this.props.messageValidated === false && (
              <div className="error-icon-wrap">
                <img src={errorIcon} alt="error-icon" />
              </div>
            )}
            <textarea
              required
              style={{
                height:
                  this.props.message !== ""
                    ? `${this.props.messageHeight}px`
                    : "21px"
              }}
              onChange={this.props.handleInputChange}
              onFocus={this.props.handleTextareaClear}
              onBlur={this.props.handleTextareaClear}
              type="textarea"
              name="message"
              id="message"
              value={this.props.message}
              rows="1"
              maxLength="3000"
              className={this.props.isFocused !== "" ? "active" : "active"}
            />
          </div>
          {this.props.isStatusInfoVisible && (
            <div className="status-info">{this.props.statusInfo}</div>
          )}
          <button type="submit" className="submit-button">
            {this.props.submitBtnText}
          </button>
        </form>
        <footer>
          <div>
            <ul>
              <li>
                dorota <a href="tel:+(48) 502 464 313">+(48) 502 464 313</a>
              </li>
              <li>
                matylda <a href="tel:+(48) 693 731 090">+(48) 693 731 090</a>
              </li>
              <li>
                email <a href="mailto:hello@moiz.eu">hello@moiz.eu</a>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.google.com/maps/place/Kolejowa+1%2F3,+60-715+Pozna%C5%84/@52.3975472,16.904696,17z/data=!3m1!4b1!4m5!3m4!1s0x47045b2c5921436f:0xf52054ddb00142!8m2!3d52.3975439!4d16.90689"
                >
                  ul.Kolejowa 1/3,<br />
                  60-715 Poznań, PL
                </a>
              </li>
            </ul>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Contact.js